module.exports = __webpack_public_path__ + "static/media/nopic.03b4cf8e.jpeg";